import './LockItemsToggle.css';

import { FC, useMemo } from 'react';
import clsx from 'clsx';
import { useLayoutEditorContext } from '../../../../../hooks/context/useLayoutEditorContext';
import { useTranslate } from '../../../../../hooks/context/useTranslate';

// Canvas-area mirror of the canvasForm lockItems checkbox (synced via patchCanvas).
const LockItemsToggle: FC = () => {
  const { t } = useTranslate();
  const { definition, canvas, patchCanvas } = useLayoutEditorContext();

  const isLocked = !!canvas.lockItems;

  // Shown only when the canvas form itself offers the lockItems control.
  const hasLockItemsControl = useMemo(
    () =>
      !!definition?.canvasForm?.items.some((item) => item.name === 'lockItems'),
    [definition]
  );

  const handleToggle = (): void => {
    patchCanvas({ lockItems: !isLocked });
  };

  if (!hasLockItemsControl) {
    return null;
  }

  return (
    <button
      type="button"
      className={clsx('layout-editor-lock-button', isLocked && 'locked')}
      title={t(
        isLocked ? 'layoutEditor.unlockItems' : 'layoutEditor.lockItems'
      )}
      aria-pressed={isLocked}
      onClick={handleToggle}
    >
      {/* Inline SVG (ionicons lock paths) — IonIcon never upgrades in the PiP document. */}
      <svg
        viewBox="0 0 512 512"
        width="15"
        height="15"
        fill="none"
        stroke="currentColor"
        strokeWidth="40"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {isLocked ? (
          <path d="M336 208v-95a80 80 0 0 0-160 0v95" />
        ) : (
          <path d="M336 112a80 80 0 0 0-160 0v96" />
        )}
        <rect x="96" y="208" width="320" height="272" rx="48" ry="48" />
      </svg>
    </button>
  );
};

export default LockItemsToggle;
